import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem, SelectLabel, SelectGroup } from "../../../../components/ui/select";
import { X } from "lucide-react";
import { Controller } from "react-hook-form";
import { Label } from "../../../../components/ui/label";
import { FieldError } from "../FieldError";
import { normalizeProducer } from "./normalizeProducer";

export function Producer({
  control,
  producers,
  producerOptions,
}) {
  return (
    <div className="space-y-2">
      <Controller
        control={control}
        name="step1.producer"
        render={({ field }) => {
          const normalized = normalizeProducer(field.value);
          const hasValue = normalized !== undefined;

          return (
            <div className="space-y-2">
              <Label htmlFor="producer">Producers</Label>
              <div className="relative">
                <Select
                  value={normalized}
                  onValueChange={(v) => field.onChange(v)}   // v is string
                  // remove onOpenChange side-effect; it can re-apply bad shapes
                  disabled={producers.loading}
                >
                  <SelectTrigger id="producer" className={`w-full ${hasValue ? "pr-9" : ""}`}>
                    <SelectValue placeholder={producers.loading ? "Loading..." : "Select a producer"} />
                  </SelectTrigger>
                  <SelectContent className="w-full max-h-60 overflow-y-auto">
                    <SelectGroup>
                      <SelectLabel>Producers</SelectLabel>
                      {producerOptions.map((opt) => (
                        <SelectItem key={opt.value} value={opt.value}>
                          {opt.label}
                        </SelectItem>
                      ))}
                    </SelectGroup>
                  </SelectContent>
                </Select>

                {hasValue && (
                  <button
                    type="button"
                    aria-label="Clear producer"
                    className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-900"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      field.onChange(undefined);
                    }}
                  >
                    <X className="h-4 w-4" />
                  </button>
                )}
              </div>
            </div>
          );
        }}
      />
      <FieldError name="step1.producer" step='step1' control={control} />
    </div>
  );
}
